import env from '../../utils/env';
import request from './request';

export const getBoxStatus = () => request(`${env.boxApi}/boxes/self/box-state`);
